import { contentSpacingStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            ${contentSpacingStyles()}
            padding-left: 1em;

            li {
                ${contentSpacingStyles(null, "0.25em")}
                padding-left: 0;
            }
        `,
    },
};
